import { useEffect, useState } from "react";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import FormFieldInput from "components/campos/input";
import FormFieldTextArea from "components/campos/textarea";
import FormFieldFileInput from "components/campos/file";
import FormFieldSelect from "components/campos/select";
import PerfilService from "../../services/PerfilService";
import canaisService from "../../services/CanaisService";
import { set } from "lodash";
import path from "path";
import { toast } from "react-toastify";

const setNestedValue = (object: any, path: string, value: any) => {
  const keys = path.split(".");
  const lastKey: any = keys.pop();
  const lastObj = keys.reduce((obj, key) => {
    if (!obj[key]) obj[key] = {};
    return obj[key];
  }, object);
  lastObj[lastKey] = value;
};

const useForm = (initialState: any) => {
  const [formData, setFormData] = useState(initialState);

  const handleChange = (fieldName: string, value: any) => {
    setFormData((prevData: any) => {
      const newData = { ...prevData };
      setNestedValue(newData, fieldName, value);
      return newData;
    });
  };

  return { formData, handleChange };
};

const camposFormTipo = (tipo: any) => {
  switch (tipo) {
    case 1:
      return {
        banner: "",
        bannerPreview: "",
        tip: {
          category_id: "",
          subcategory_id: "",
          name: "",
          subtitle: "",
          description: "",
          site: "",
          email: "",
          phone: "",
        },
        address: {
          country: "",
          state: "",
          city: "",
          postal_code: "",
          address: "",
          number: "",
          district: "",
          complement: "",
        },
      };
    case 2:
      return {
        classified: {
          category_id: "",
          subcategory_id: "",
          name: "",
          description: "",
          currency_id: "",
          value: "",
        },
        address: {
          country: "",
          state: "",
          city: "",
          postal_code: "",
          address: "",
          number: "",
          district: "",
          complement: "",
        },
      };
    case 3:
      return {
        logo: "",
        logoPreview: "",
        banner: "",
        bannerPreview: "",
        partnership: {
          category_id: "",
          subcategory_id: "",
          name: "",
          title: "",
          description: "",
          about_us: "",
          benefits: "",
          url_video: "",
          url: "",
          email: "",
          phone: "",
          instagram: "",
          linkedin: "",
          facebook: "",
          youtube: "",
          tiktok: "",
          is_social: false,
        },
        address: {
          country: "",
          state: "",
          city: "",
          postal_code: "",
          address: "",
          number: "",
          district: "",
          complement: "",
        },
      };
    case 4:
      return {
        logo: "",
        logoPreview: "",
        banner: "",
        bannerPreview: "",
        event: {
          category_id: "",
          subcategory_id: "",
          name: "",
          description: "",
          initial_date: "",
          final_date: "",
        },
        address: {
          country: "",
          state: "",
          city: "",
          postal_code: "",
          address: "",
          number: "",
          district: "",
          complement: "",
        },
      };
  }
};

const FormDinamic = ({
  nomeTela,
  tipoTela,
  acaoVoltar,
  dados = null,
  acaoCadastrado = null,
}: any) => {
  const { formData, handleChange } = useForm(camposFormTipo(tipoTela));

  const [loading, setLoading] = useState(false);
  const [listCategories, setListCategories]: any = useState([]);
  const [listSubCategories, setListSubCategories]: any = useState([]);
  const [subCategoriasGeral, setSubCategoriaGeral] = useState([]);
  const [groupCities, setGroupCities] = useState([]);

  const [subCategoriaSelected, setSubCategoriaSelected] = useState(null);
  const [categoriaSelected, setCategoriaSelected] = useState(null);
  const [groupCitySelected, setGroupCitySelected] = useState(null);

  const [anexos, setAnexos]: any = useState(null);

  useEffect(() => {
    if (tipoTela == 1) {
      getCanais(1);
    }

    if (tipoTela == 2) {
      getCanais(4);
    }

    if (tipoTela == 3) {
      getCanais(5);
    }

    if (tipoTela == 4) {
      getCanais(2);
    }
  }, []);

  const getCanais = async (idTipo: any) => {
    setLoading(true); // start loading
    await canaisService
      .getCanais(idTipo, "")
      .then((response: any) => {
        let newListCategories = response.categories.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        setListCategories(newListCategories);

        setSubCategoriaGeral(response.subcategories);
        setSubCategoriaSelected(null);
        setGroupCitySelected(null);

        let newSubCategories: any = response.subcategories.filter(
          (item: any) => item.category_id == categoriaSelected
        );

        newSubCategories = newSubCategories.map((item: any) => {
          return { value: item.id, label: item.name };
        });

        setListSubCategories(newSubCategories);

        if (response.group_cities) {
          let newGroupCities: any = response.group_cities.map((item: any) => {
            return { value: item.id, label: item.name };
          });

          setGroupCities(newGroupCities);
        }
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (tipoTela == 1) {
      if (dados != null) {
        handleChange("tip.category_id", dados?.category_id);
        handleChange("tip.subcategory_id", dados?.subcategory_id);
        handleChange("tip.name", dados?.name);
        handleChange("tip.subtitle", dados?.subtitle);
        handleChange("tip.description", dados?.description);
        handleChange("tip.site", dados?.site);
        handleChange("tip.email", dados?.email);
        handleChange("tip.phone", dados?.phone);
        handleChange("bannerPreview", dados?.banner_path);
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);
        handleChange("post.group_city_id", dados?.post?.group_city_id);

        selecionarCategoria(dados?.category_id);
      }
    }

    if (tipoTela == 2) {
      if (dados != null) {
        handleChange("classified.category_id", dados?.category_id);
        handleChange("classified.subcategory_id", dados?.subcategory_id);
        handleChange("classified.name", dados?.name);
        handleChange("classified.description", dados?.description);
        handleChange("classified.currency_id", dados?.currency_id);
        handleChange("classified.value", dados?.value);
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);

        selecionarCategoria(dados?.category_id);
      }
    }

    if (tipoTela == 3) {
      if (dados != null) {
        handleChange("partnership.category_id", dados?.category_id);
        handleChange("partnership.subcategory_id", dados?.subcategory_id);
        handleChange("partnership.name", dados?.name);
        handleChange("partnership.title", dados?.title);
        handleChange("partnership.description", dados?.description);
        handleChange("partnership.about_us", dados?.about_us);
        handleChange("partnership.benefits", dados?.benefits);
        handleChange("partnership.url_video", dados?.url_video);
        handleChange("partnership.url", dados?.url);
        handleChange("partnership.email", dados?.email);
        handleChange("partnership.phone", dados?.phone);
        handleChange("partnership.instagram", dados?.instagram);
        handleChange("partnership.linkedin", dados?.linkedin);
        handleChange("partnership.facebook", dados?.facebook);
        handleChange("partnership.youtube", dados?.youtube);
        handleChange("partnership.tiktok", dados?.tiktok);
        handleChange("partnership.is_social", dados?.is_social);
        handleChange("logoPreview", dados?.logo_path);
        handleChange("bannerPreview", dados?.banner_path);
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);

        selecionarCategoria(dados?.category_id);
      }
    }

    if (tipoTela == 4) {
      if (dados != null) {
        handleChange("event.category_id", dados?.category_id);
        handleChange("event.subcategory_id", dados?.subcategory_id);
        handleChange("event.name", dados?.name);
        handleChange("event.description", dados?.description);
        handleChange("event.initial_date", dados?.initial_date);
        handleChange("event.final_date", dados?.final_date);
        handleChange("logoPreview", dados?.logo_path);
        handleChange("bannerPreview", dados?.banner_path);
        handleChange("address.country", dados?.address?.country);
        handleChange("address.state", dados?.address?.state);
        handleChange("address.city", dados?.address?.city);
        handleChange("address.postal_code", dados?.address?.postal_code);
        handleChange("address.address", dados?.address?.address);
        handleChange("address.number", dados?.address?.number);
        handleChange("address.district", dados?.address?.district);
        handleChange("address.complement", dados?.address?.complement);

        selecionarCategoria(dados?.category_id);
      }
    }

    if (dados != null) {
      setAnexos(dados.attachments);
    }
  }, [subCategoriasGeral]);

  const selecionarCategoria = (Idcategoria: any) => {
    setCategoriaSelected(Idcategoria);
    setSubCategoriaSelected(null);
    setListSubCategories([]);

    let newSubCategories: any = subCategoriasGeral.filter(
      (item: any) => item.category_id == Idcategoria
    );

    newSubCategories = newSubCategories.map((item: any) => {
      return { value: item.id, label: item.name };
    });

    setListSubCategories(newSubCategories);
    if (dados == null) {
      handleChange("event.subcategory_id", "");
    }
  };

  const handleGroupCityChange = (IdGroupCity: any) => {
    setGroupCitySelected(IdGroupCity);
  }

  const storedUserData = localStorage.getItem("userData");
  const initialUserData = storedUserData ? JSON.parse(storedUserData) : {};
  const [dadosUser, setDadosUser] = useState(initialUserData);

  const enviarDados = async () => {
    let newDados: any = {};
    let caminho = "";

    if (tipoTela == 1) {
      newDados = {
        tip: {
          category_id: formData.tip.category_id,
          subcategory_id: formData.tip.subcategory_id,
          name: formData.tip.name,
          subtitle: formData.tip.subtitle,
          description: formData.tip.description,
          site: formData.tip.site,
          email: formData.tip.email,
          phone: formData.tip.phone,
          banner: formData.banner,
        },

        address: {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        },

        post: {
          group_city_id: formData.post.group_city_id,
        }
      };
      caminho = "/posts/tips";
    }

    if (tipoTela == 2) {
      newDados = {
        classified: {
          category_id: formData.classified.category_id,
          subcategory_id: formData.classified.subcategory_id,
          name: formData.classified.name,
          description: formData.classified.description,
          currency_id: formData.classified.currency_id,
          value: formData.classified.value,
        },
        address: {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        },
      };
      caminho = "/posts/classifieds";
    }

    if (tipoTela == 3) {
      newDados = {
        partnership: {
          category_id: formData.partnership.category_id,
          subcategory_id: formData.partnership.subcategory_id,
          name: formData.partnership.name,
          title: formData.partnership.title,
          description: formData.partnership.description,
          about_us: formData.partnership.about_us,
          benefits: formData.partnership.benefits,
          url_video: formData.partnership.url_video,
          url: formData.partnership.url,
          email: formData.partnership.email,
          phone: formData.partnership.phone,
          instagram: formData.partnership.instagram,
          linkedin: formData.partnership.linkedin,
          facebook: formData.partnership.facebook,
          youtube: formData.partnership.youtube,
          tiktok: formData.partnership.tiktok,
          is_social: formData.partnership.is_social,
          banner: formData.banner,
          logo: formData.logo,
        },
        address: {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        },
      };
      caminho = "/posts/partnerships";
    }

    if (tipoTela == 4) {
      newDados = {
        event: {
          category_id: formData.event.category_id,
          subcategory_id: formData.event.subcategory_id,
          name: formData.event.name,
          description: formData.event.description,
          initial_date: formData.event.initial_date,
          final_date: formData.event.final_date,
          logo: formData.logo,
          banner: formData.banner,
        },
        address: {
          country: formData.address.country,
          state: formData.address.state,
          city: formData.address.city,
          postal_code: formData.address.postal_code,
          address: formData.address.address,
          number: formData.address.number,
          district: formData.address.district,
          complement: formData.address.complement,
        },
      };
      caminho = "/posts/events";
    }

    if (dados == null) {
      newDados = removerCamposVazios(newDados);
      await PerfilService.postDados(newDados, caminho)
        .then((response: any) => {
          if (response.id != undefined) {
            // alert("Dados enviados com sucesso!");
            toast.success("Dados enviados com sucesso!");
            acaoCadastrado(response);
          } else {
            //alert(response.response.data.message);
            toast.error(response.response.data.message);
          }
        })
        .catch((error: any) => {
          //console.error("veio pra ca: ", error);
        });
    } else {
      if (tipoTela == 1) {
        newDados = verificarBannerDica(newDados);
        newDados = removerCamposVazios(newDados);
        if (!newDados.tip.banner_path) {
          newDados.tip.banner_path = "";
        }
      }
      if (tipoTela == 3) {
        newDados = verificarLogoParceria(newDados);
        newDados = verificarBannerParceria(newDados);
        newDados = removerCamposVazios(newDados);

        if (!newDados.partnership.logo_path) {
          newDados.partnership.logo_path = "";
        }

        if (!newDados.partnership.banner_path) {
          newDados.partnership.banner_path = "";
        }
      }

      if (tipoTela == 4) {
        newDados = verificarLogoEvent(newDados);
        newDados = verificarBannerEvent(newDados);
        newDados = removerCamposVazios(newDados);

        if (!newDados.event.logo_path) {
          newDados.event.logo_path = "";
        }

        if (!newDados.event.banner_path) {
          newDados.event.banner_path = "";
        }
      }

      //

      await PerfilService.updateDados(newDados, caminho, dados.id)
        .then((response: any) => {
          if (response.id != undefined) {
            //alert("Dados editado com sucesso!");
            toast.success("Dados editado com sucesso!");
          } else {
            //alert(response.response.data.message);
            toast.error(response.response.data.message);
          }
        })
        .catch((error: any) => {
          //console.error("veio pra ca: ", error);
        });
    }
  };

  const removerCamposVazios = (obj: any) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] && typeof obj[key] === "object") {
        removerCamposVazios(obj[key]);
      } else if (obj[key] === null || obj[key] === "") {
        delete obj[key];
      }
    });
    return obj;
  };

  const verificarBannerDica = (obj: any) => {
    if (obj.tip.banner == "") {
      obj.tip.banner_path = dados.banner_path;
    }

    return obj;
  };

  const verificarLogoParceria = (obj: any) => {
    if (obj.partnership.logo == "") {
      obj.partnership.logo_path = dados.logo_path;
    }

    return obj;
  };

  const verificarBannerParceria = (obj: any) => {
    if (obj.partnership.banner == "") {
      obj.partnership.banner_path = dados.banner_path;
    }

    return obj;
  };

  const verificarLogoEvent = (obj: any) => {
    if (obj.event.logo == "") {
      obj.event.logo_path = dados.logo_path;
    }

    return obj;
  };

  const verificarBannerEvent = (obj: any) => {
    if (obj.event.banner == "") {
      obj.event.banner_path = dados.banner_path;
    }

    return obj;
  };

  const optionsMoeda = [
    { value: "1", label: "Real" },
    { value: "2", label: "Dolar" },
    { value: "3", label: "Euro" },
  ];

  const renderFormField = (config: any) => {
    //tipo: "select", label: "Categoria", fieldName: "categoria", options: optionsCategoria, defaultValue: 1, classe: 1
    const {
      tipo,
      label,
      fieldName,
      options,
      extraProps,
      classe,
      action = null,
    } = config;
    switch (tipo) {
      case "select":
        return (
          <FormFieldSelect
            key={fieldName}
            label={label}
            fieldName={fieldName}
            options={options}
            formData={formData}
            handleChange={handleChange}
            classe={classe}
            action={action}
          />
        );
      case "file":
        return (
          <FormFieldFileInput
            key={fieldName}
            label={label}
            fieldName={fieldName}
            formData={formData}
            handleChange={handleChange}
            classNameImagem={""}
            tipo={tipoTela}
          />
        );
      case "textarea":
        return (
          <FormFieldTextArea
            key={fieldName}
            label={label}
            fieldName={fieldName}
            extraProps={extraProps}
            formData={formData}
            handleChange={handleChange}
          />
        );
      default:
        return (
          <FormFieldInput
            key={fieldName}
            label={label}
            fieldName={fieldName}
            type={tipo}
            extraProps={extraProps}
            formData={formData}
            handleChange={handleChange}
            classe={classe}
          />
        );
    }
  };

  const renderFormFields = (fields: any[]) =>
    fields.map((field) => renderFormField(field));

  const fieldsByType: any = {
    1: [
      {
        tipo: "select",
        label: "Categoria",
        fieldName: "tip.category_id",
        options: listCategories,
        action: selecionarCategoria,
      },
      {
        tipo: "select",
        label: "Subcategoria",
        fieldName: "tip.subcategory_id",
        options: listSubCategories,
      },
      {
        tipo: "text",
        label: "Nome",
        fieldName: "tip.name",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "text",
        label: "Subtitulo",
        fieldName: "tip.subtitle",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "textarea",
        label: "Descrição",
        fieldName: "tip.description",
        extraProps: { rows: 8 },
      },
      {
        tipo: "select",
        label: "Grupo de Cidades",
        fieldName: "post.group_city_id",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
        options: groupCities,
        action: handleGroupCityChange,
      },
      { tipo: "text", label: "Site", fieldName: "tip.site" },
      { tipo: "text", label: "Email", fieldName: "tip.email" },
      { tipo: "text", label: "Telefone", fieldName: "tip.phone" },
      { tipo: "text", label: "Pais", fieldName: "address.country" },
      { tipo: "text", label: "Estado", fieldName: "address.state" },
      { tipo: "text", label: "Cidade", fieldName: "address.city" },
      { tipo: "text", label: "CEP", fieldName: "address.postal_code" },
      { tipo: "text", label: "Endereço", fieldName: "address.address" },
      { tipo: "text", label: "Número", fieldName: "address.number" },
      { tipo: "text", label: "Bairro", fieldName: "address.district" },
      {
        tipo: "text",
        label: "Complemento",
        fieldName: "address.complement",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      { tipo: "file", label: "Banner", fieldName: "banner" },
    ],
    2: [
      {
        tipo: "select",
        label: "Categoria",
        fieldName: "classified.category_id",
        options: listCategories,
        action: selecionarCategoria,
      },
      {
        tipo: "select",
        label: "Subcategoria",
        fieldName: "classified.subcategory_id",
        options: listSubCategories,
      },
      {
        tipo: "text",
        label: "Titulo",
        fieldName: "classified.name",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "textarea",
        label: "Descrição",
        fieldName: "classified.description",
        extraProps: { rows: 8 },
      },
      {
        tipo: "select",
        label: "Moeda",
        fieldName: "classified.currency_id",
        options: optionsMoeda,
      },
      { tipo: "number", label: "Valor", fieldName: "classified.value" },
      { tipo: "text", label: "Pais", fieldName: "address.country" },
      { tipo: "text", label: "Estado", fieldName: "address.state" },
      { tipo: "text", label: "Cidade", fieldName: "address.city" },
      { tipo: "text", label: "CEP", fieldName: "address.postal_code" },
      { tipo: "text", label: "Endereço", fieldName: "address.address" },
      { tipo: "text", label: "Número", fieldName: "address.number" },
      { tipo: "text", label: "Bairro", fieldName: "address.district" },
      { tipo: "text", label: "Complemento", fieldName: "address.complement" },
    ],
    3: [
      {
        tipo: "select",
        label: "Categoria",
        fieldName: "partnership.category_id",
        options: listCategories,
        action: selecionarCategoria,
      },
      {
        tipo: "select",
        label: "Subcategoria",
        fieldName: "partnership.subcategory_id",
        options: listSubCategories,
      },
      {
        tipo: "text",
        label: "Nome",
        fieldName: "partnership.name",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "text",
        label: "Título",
        fieldName: "partnership.title",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "textarea",
        label: "Descrição",
        fieldName: "partnership.description",
        extraProps: { rows: 8 },
      },
      {
        tipo: "textarea",
        label: "Sobre Nós",
        fieldName: "partnership.about_us",
        extraProps: { rows: 8 },
      },
      {
        tipo: "textarea",
        label: "Benefícios ou como Contribuir",
        fieldName: "partnership.benefits",
        extraProps: { rows: 8 },
      },
      { tipo: "text", label: "URL Vídeo", fieldName: "partnership.url_video" },
      { tipo: "text", label: "URL", fieldName: "partnership.url" },
      { tipo: "text", label: "Email", fieldName: "partnership.email" },
      { tipo: "text", label: "Telefone", fieldName: "partnership.phone" },
      { tipo: "text", label: "Instagram", fieldName: "partnership.instagram" },
      { tipo: "text", label: "Linkedin", fieldName: "partnership.linkedin" },
      { tipo: "text", label: "Facebook", fieldName: "partnership.facebook" },
      { tipo: "text", label: "Youtube", fieldName: "partnership.youtube" },
      { tipo: "text", label: "Tiktok", fieldName: "partnership.tiktok" },
      {
        tipo: "select",
        label: "Social",
        fieldName: "partnership.is_social",
        options: [
          { value: 1, label: "Sim" },
          { value: 0, label: "Não" },
        ],
      },
      { tipo: "file", label: "Logo", fieldName: "logo" },
      { tipo: "file", label: "Banner", fieldName: "banner" },
      { tipo: "text", label: "Pais", fieldName: "address.country" },
      { tipo: "text", label: "Estado", fieldName: "address.state" },
      { tipo: "text", label: "Cidade", fieldName: "address.city" },
      { tipo: "text", label: "CEP", fieldName: "address.postal_code" },
      { tipo: "text", label: "Endereço", fieldName: "address.address" },
      { tipo: "text", label: "Número", fieldName: "address.number" },
      { tipo: "text", label: "Bairro", fieldName: "address.district" },
      { tipo: "text", label: "Complemento", fieldName: "address.complement" },
    ],
    4: [
      {
        tipo: "select",
        label: "Categoria",
        fieldName: "event.category_id",
        options: listCategories,
        action: selecionarCategoria,
      },
      {
        tipo: "select",
        label: "Subcategoria",
        fieldName: "event.subcategory_id",
        options: listSubCategories,
      },
      {
        tipo: "text",
        label: "Nome",
        fieldName: "event.name",
        type: "text",
        extraProps: { mdColSpan: 2 },
        classe: "md:col-span-2",
      },
      {
        tipo: "textarea",
        label: "Descrição",
        fieldName: "event.description",
        extraProps: { rows: 8 },
      },
      { tipo: "date", label: "Data Inicial", fieldName: "event.initial_date" },
      { tipo: "date", label: "Data Final", fieldName: "event.final_date" },
      { tipo: "file", label: "Logo", fieldName: "logo" },
      { tipo: "file", label: "Banner", fieldName: "banner" },
      { tipo: "text", label: "Pais", fieldName: "address.country" },
      { tipo: "text", label: "Estado", fieldName: "address.state" },
      { tipo: "text", label: "Cidade", fieldName: "address.city" },
      { tipo: "text", label: "CEP", fieldName: "address.postal_code" },
      { tipo: "text", label: "Endereço", fieldName: "address.address" },
      { tipo: "text", label: "Número", fieldName: "address.number" },
      { tipo: "text", label: "Bairro", fieldName: "address.district" },
      { tipo: "text", label: "Complemento", fieldName: "address.complement" },
    ],
    // adicione mais tipos conforme necessário
  };

  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;

  const onChangeAnexo = async (e: any) => {
    const reader = new FileReader();
    const files = e.target.files;

    if (files.length === 0) {
      return;
    }

    let NewListAnexos: any = anexos;
    setAnexos(null);

    let attachment = {
      attachment: {
        file: files[0],
      },
    };

    let caminhoFile = "";

    if (tipoTela == 1) {
      caminhoFile = `/posts/tips/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 2) {
      caminhoFile = `/posts/classifieds/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 3) {
      caminhoFile = `/posts/partnerships/${dados.id}/attachment/upload`;
    }

    if (tipoTela == 4) {
      caminhoFile = `/posts/events/${dados.id}/attachment/upload`;
    }

    await PerfilService.uploadFile(attachment, caminhoFile)
      .then((response: any) => {
        if (response.id != undefined) {
          NewListAnexos.push(response);
          setAnexos(NewListAnexos);
          toast.success("Anexo enviado com sucesso!");
        } else {
          // alert(response.response.data.message);
          toast.error(response.response.data.message);
        }
      })
      .catch((error: any) => {
        //console.error("veio pra ca: ", error);
      });

    // reader.onload = async function () {};

    // reader.readAsDataURL(files[0]);

    // setAnexo(files[0]);
    // handleChange(fieldName, files[0]);
  };

  const renderAttachments = () => {
    let caminhoAnexo = "/storage/images/posts/events/attachments/";
    if (tipoTela == 1) {
      caminhoAnexo = "/storage/images/posts/tips/attachments/";
    }

    if (tipoTela == 2) {
      caminhoAnexo = "/storage/images/posts/classifieds/attachments/";
    }

    if (tipoTela == 3) {
      caminhoAnexo = "/storage/images/posts/partnerships/attachments/";
    }

    if (tipoTela == 4) {
      caminhoAnexo = "/storage/images/posts/events/attachments/";
    }

    return (
      <>
        <h3>Lista de anexos</h3>
        <div className="gap-6" style={{ display: "flex", flexWrap: "wrap" }}>
          {anexos &&
            anexos.map((attachment: any) => (
              <>
                <div className="centralizarAnexo">
                  <div className="m-1 wil-avatar relative flex-shrink-0 inline-flex items-center justify-center overflow-hidden text-neutral-100 uppercase font-semibold rounded-full w-10 h-20 text-xl lg:text-2xl lg:w-20 lg:h-20 ring-4 ring-white dark:ring-0 shadow-2xl z-0">
                    <img
                      alt="Avatar"
                      src={urlBaseApi + caminhoAnexo + attachment.path}
                      className="object-cover"
                    />
                  </div>
                  <ButtonPrimary
                    className="m-2 shadow-2xl z-0"
                    type="button"
                    onClick={() => removerAnexo(attachment)}
                  >
                    Remover
                  </ButtonPrimary>
                </div>
              </>
            ))}
          <input
            type="file"
            style={{ display: "none" }}
            onChange={onChangeAnexo}
          />
          <ButtonPrimary
            className="m-2  text-xl lg:text-2xl lg:w-20 lg:h-20 ring-4 ring-white dark:ring-0 shadow-2xl z-0"
            type="button"
            onClick={executarFileInput}
          >
            +
          </ButtonPrimary>
        </div>
        <br />
      </>
    );
  };

  const executarFileInput = () => {
    const fileInput: any = document.querySelector("input[type='file']");
    fileInput?.click();
  };

  const removerAnexo = async (attachment: any) => {
    let caminhoFile = "";

    if (tipoTela == 1) {
      caminhoFile = `/posts/tips/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 2) {
      caminhoFile = `/posts/classifieds/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 3) {
      caminhoFile = `/posts/partnerships/${attachment.id}/attachment/remove`;
    }

    if (tipoTela == 4) {
      caminhoFile = `/posts/events/${attachment.id}/attachment/remove`;
    }

    await PerfilService.removeFile(caminhoFile)
      .then((response: any) => {
        let newList = anexos.filter((item: any) => item.id != attachment.id);
        setAnexos(newList);

        toast.success("Anexo removido com sucesso!");
      })
      .catch((error: any) => {
        //console.error("veio pra ca: ", error);
      });
  };

  return (
    <>
      <div className="flex-end">
        <ButtonPrimary
          className="md:col-span-2"
          type="button"
          onClick={() => acaoVoltar(false)}
        >
          Voltar
        </ButtonPrimary>
      </div>
      <br />
      <div className="rounded-xl md:border md:border-neutral-100 dark:border-neutral-800 md:p-6">
        {dados != null && renderAttachments()}
        <form className="grid md:grid-cols-2 gap-6" action="#" method="post">
          {renderFormFields(fieldsByType[tipoTela])}

          <ButtonPrimary
            className="md:col-span-2"
            type="button"
            onClick={enviarDados}
          >
            Salvar
          </ButtonPrimary>
        </form>
      </div>
    </>
  );
};

export default FormDinamic;
